import React, { Component } from 'react';
import { Row, Col, Button, Input } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate, I18n } from 'react-redux-i18n';
import ContentWrapper from '../Layout/ContentWrapper';

class SerialNumDetailModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      serialNums: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
    };
  }

  componentDidMount() {
    let rows = []
    let currentSerialNo = this.props.currentSerialNo ? this.props.currentSerialNo.split(',') : [];
    let restockSerialNo = this.props.restockSerialNo ? this.props.restockSerialNo.split(',') : [];
    for (let i = 0; i < currentSerialNo.length; i++) {
      let IsRestock = restockSerialNo.includes(currentSerialNo[i]) ? I18n.t("yes") : I18n.t("no")
      rows.push({ Num: currentSerialNo[i] || '', IsRestock });
    }
    const serialNums = { ...this.state.serialNums, rows };
    this.setState({ serialNums, rows });
  }

  renderNumInputs() {
    const getRows = () => Data.Selectors.getRows(this.state.serialNums);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx+1 }, rows[rowIdx]);
    };

    const columns = [
      {
        key: 'Idx',
        name: <Translate value="index" />,
        width: 50,
        resizable: false,
        filterable: true,
      },
      {
        key: 'Num',
        name: <Translate value="serial_no" />,
        width: 240,
        getRowMetaData: row => row,
        formatter: ({value, dependentValues})=> {
          return  <span> {value} </span>
        }
      },
      {
        key: 'IsRestock',
        name: <Translate value="is_restock" />,
        width: 120,
        getRowMetaData: row => row,
        formatter: ({value, dependentValues})=> {
          return  <span> {value} </span>
        }
      },
    ];
 
    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: '99%' }}>
            {
                <div id="SetNumDetailModal-dataGrid3">
                  <ReactDataGrid
                    style={{ height: '10%' }}
                    columns={columns}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    minHeight={275}
                  />
                </div>
            }
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <ContentWrapper>
        {this.renderNumInputs()}
        <Row>
        </Row>
      </ContentWrapper>
    );
  }
}

export default SerialNumDetailModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/serialNumDetailModal.jsx